// src/config/env.vite.ts

export function getEnvVariable(key: string, defaultValue?: string): string {
  if (import.meta.env[key]) {
    return import.meta.env[key] as string;
  }

  if (defaultValue !== undefined) return defaultValue;

  throw new Error(
    `Environment variable "${key}" is not defined and no default value was provided.`,
  );
}
